import { isValidElement } from "react";

export interface BaseIconProps {
  id?: string;
  "aria-label"?: string;
  size?: number;
  className?: string;
  tone?: Tone;
  color?: string | Readonly<[startColor: string, endColor: string]>;
}

export const Tone = {
  NONE: "none",
  PRIMARY: "primary",
  ASSIST: "assist",
  SUCCESS: "success",
  WARNING: "warning",
  DANGER: "danger",
} as const;
export type Tone = (typeof Tone)[keyof typeof Tone];

export const IconDisplayName = "icon";

export function isIconType(type: unknown): type is React.ReactElement<BaseIconProps> {
  if (isValidElement(type) && isIconType(type.type)) {
    return true;
  }

  return !!type && (typeof type === "function" || typeof type === "object") && "displayName" in type && type.displayName === IconDisplayName;
}

export enum IconSize {
  STANDARD = 16,
  LARGE = 20,
}

export type IconPaths = string[];
